module.exports = __webpack_public_path__ + "img/news-center.58dcc3b1.png";